"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMedalCheckFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.medal-check_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "medal-check_filled_svg__transparent_box" },
            React.createElement("path", { className: "medal-check_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "medal-check_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "medal-check_filled_svg__FILLED" },
            React.createElement("path", { d: "M9 22.94v8.68l7-3.5 7 3.5v-8.68a12.92 12.92 0 01-14 0z" }),
            React.createElement("path", { d: "M16 1a11 11 0 1011 11A11 11 0 0016 1zm4.63 9.83l-5.11 5.09-3.94-4 1.47-1.36 2.49 2.49L20.63 8z" }))));
}
exports.default = SvgMedalCheckFilled;
//# sourceMappingURL=MedalCheckFilled.js.map